module.exports = __webpack_public_path__ + "static/frontUserNew/img/codesbg-main.eb465303.png";